import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Force dark theme - light theme disabled but code kept for future use
  const theme = 'dark';

  useEffect(() => {
    // Always set to dark theme
    localStorage.setItem('theme', 'dark');
    document.documentElement.setAttribute('data-theme', 'dark');
  }, []); // Empty dependency array - only run once on mount

  // Toggle function kept for future use but disabled
  const toggleTheme = () => {
    // Disabled - always stays on dark theme
    // setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
    // Uncomment above line to re-enable theme toggle in the future
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
